// replacement for the (unmaintained) aos.js library

const createObserver = () => {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("aos-animate");
        observer.unobserve(entry.target);
      }
    });
  });

  return observer;
};

const init = () => {
  const observer = createObserver();

  const elements = document.querySelectorAll("[data-aos]");
  elements.forEach(element => {
    observer.observe(element);
  });
};

export default {
  init
};
